import { useContext, useState } from 'react'

import AppContext from '@/context/AppContext'

const useGiftReturn = () => {
  const { context, setContext } = useContext(AppContext)
  const [isGiftReturn, setIsGiftReturn] = useState(false)

  const handleSetIsGiftReturn = value => {
    setIsGiftReturn(value)
    if (!value) {
      setContext(prev => {
        const orderInfo = { ...prev.orderInfo }
        delete orderInfo.gift_recipient
        return { ...prev, orderInfo }
      })
    }
  }

  const setGiftRecipient = giftRecipient => {
    setContext(prev => ({
      ...prev,
      orderInfo: { ...prev.orderInfo, gift_recipient: giftRecipient },
    }))
  }

  const handleGiftRecipientChange = (property, value) => {
    const currentRecipient = context?.orderInfo?.gift_recipient || {}
    setGiftRecipient({ ...currentRecipient, [property]: value })
  }

  const handleReturnToRegularOrder = () => handleSetIsGiftReturn(false)
  const handleReturnToGiftReturn = () => handleSetIsGiftReturn(true)

  return {
    isGiftReturn,
    setIsGiftReturn: handleSetIsGiftReturn,
    giftRecipient: context?.orderInfo?.gift_recipient,
    setGiftRecipient,
    handleGiftRecipientChange,
    handleReturnToRegularOrder,
    handleReturnToGiftReturn,
  }
}

export default useGiftReturn
